import { BATCH_STAGE_LABEL } from '@/constants/batchStages';
import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const DEFAULT_MP_PAGE_SIZE = 50;

export const DONATION_ITEM_LOOKUP_PARAMS = { isActive: true, page: 1, pageSize: 200 } as const;

export const BUDGET_HOLDER_LABEL = 'Budget Holder';

export const DONATION_SEARCH_PLACEHOLDER = 'Institute, EIIN, teacher, ZM or mobile';

export const DONATION_BATCH_STAGE_LABEL: Record<string, string> = {
  ...BATCH_STAGE_LABEL,
  awaiting_mis: 'Awaiting Confirm',
};

export const DONATION_BATCH_ORIGIN = {
  publish: '/market-promotion/publish-panel',
  accounts: '/market-promotion/accounts-adjust',
} as const;

export type DonationBatchOrigin =
  (typeof DONATION_BATCH_ORIGIN)[keyof typeof DONATION_BATCH_ORIGIN];

export const REGION_REPORT_PATH = '/market-promotion/region-summary';
export const REGION_DONATIONS_PATH = '/market-promotion/region-summary/donations';

export const REGION_REPORT_TAB = {
  regions: 'regions',
  projects: 'projects',
} as const;

export type RegionReportTab = (typeof REGION_REPORT_TAB)[keyof typeof REGION_REPORT_TAB];

export const DONATION_DETAIL_ORIGIN = {
  approvals: '/market-promotion/approvals',
  mis: '/market-promotion/mis-approvals',
  approvalReport: '/market-promotion/approval-report',
  cashCollection: '/market-promotion/cash-collection',
} as const;

export type DonationDetailOrigin =
  (typeof DONATION_DETAIL_ORIGIN)[keyof typeof DONATION_DETAIL_ORIGIN];

export const DONATION_DECISION = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  RECOMMENDED: 3,
} as const;

export const DONATION_DECISION_STEP = {
  recommend: 'recommend',
  approve: 'approve',
} as const;

export type DonationDecisionStep =
  (typeof DONATION_DECISION_STEP)[keyof typeof DONATION_DECISION_STEP];

export const DECISION_OPTIONS = [
  { id: DONATION_DECISION.PENDING, name: 'Pending' },
  { id: DONATION_DECISION.RECOMMENDED, name: 'Recommended' },
  { id: DONATION_DECISION.APPROVED, name: 'Approved' },
  { id: DONATION_DECISION.REJECTED, name: 'Rejected' },
] as const;

export const DECISION_LABEL: Record<number, string> = {
  [DONATION_DECISION.PENDING]: 'Pending',
  [DONATION_DECISION.RECOMMENDED]: 'Recommended',
  [DONATION_DECISION.APPROVED]: 'Approved',
  [DONATION_DECISION.REJECTED]: 'Rejected',
};

export const CALL_RESULT_OPTIONS = [
  { id: 1, name: 'Verified' },
  { id: 2, name: 'No Answer' },
  { id: 3, name: 'User Busy' },
  { id: 4, name: 'Switch Off' },
  { id: 5, name: 'Wrong Number' },
  { id: 6, name: 'Invalid Number' },
  { id: 7, name: 'Call Later' },
] as const;

export const TEACHER_ANSWER_OPTIONS = [
  { id: 1, name: 'Received' },
  { id: 2, name: 'Partially' },
  { id: 3, name: 'No Said' },
  { id: 4, name: 'Received Gift' },
  { id: 5, name: 'Did not Receive' },
  { id: 6, name: 'Date not Matched' },
] as const;

export const SOURCE_INSTITUTE_MIN_SEARCH_LENGTH = 3;

export const DONATION_COMMENT_MAX_LENGTH = 2000;

export const DECISION_COMMENT_MIN_LENGTH = 30;

export const DONATION_FILE_ACCEPT = '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.ppt';

export const DONATION_IMAGE_LABELS = ['Image 1', 'Image 2', 'Image 3'] as const;

export const PAYMENT_TYPE_OPTIONS = [
  { id: 1, name: 'Cash' },
  { id: 2, name: 'bKash' },
  { id: 3, name: 'Nagad' },
  { id: 4, name: 'Rocket' },
  { id: 5, name: 'Upay' },
  { id: 6, name: 'CellFin' },
  { id: 7, name: 'Gift' },
  { id: 8, name: 'Bank' },
  { id: 9, name: 'Others' },
] as const;

export const PAYMENT_TYPES_WITH_TRANSACTION_REF: readonly string[] = [
  'bKash',
  'Nagad',
  'Rocket',
  'Upay',
  'CellFin',
];

export const PAYMENT_PLACE_OPTIONS = [
  { id: 1, name: 'School' },
  { id: 2, name: 'College' },
  { id: 3, name: 'Madrasha' },
  { id: 4, name: 'Library' },
  { id: 5, name: 'Home' },
  { id: 6, name: 'Others' },
] as const;

export const CALL_RESULT_LABEL: Partial<Record<number, string>> = Object.fromEntries(
  CALL_RESULT_OPTIONS.map((option) => [option.id, option.name]),
);

export const TEACHER_ANSWER_LABEL: Partial<Record<number, string>> = Object.fromEntries(
  TEACHER_ANSWER_OPTIONS.map((option) => [option.id, option.name]),
);

export const DECISION_TONE: Partial<Record<number, StatusColorTone>> = {
  [DONATION_DECISION.PENDING]: APPROVAL_STATUS_TONE.pending,
  [DONATION_DECISION.RECOMMENDED]: APPROVAL_STATUS_TONE.recommended,
  [DONATION_DECISION.APPROVED]: APPROVAL_STATUS_TONE.approved,
  [DONATION_DECISION.REJECTED]: APPROVAL_STATUS_TONE.rejected,
};
